// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3kZSl","tab":"ProcedureTabs_tab__2ga2O"};